import { create } from "zustand";
import type { KioskFlow, TerminalConfiguration } from "./types";

type KioskScreen = "attract" | "home" | "flow";

type KioskState = {
  screen: KioskScreen;
  activeFlow: KioskFlow | null;
  configuration: TerminalConfiguration | null;
  setConfiguration: (configuration: TerminalConfiguration | null) => void;
  showAttract: () => void;
  showHome: () => void;
  openFlow: (flow: KioskFlow) => void;
  resetSession: () => void;
};

export const useKioskStore = create<KioskState>((set) => ({
  screen: "attract",
  activeFlow: null,
  configuration: null,
  setConfiguration: (configuration) => set({ configuration }),
  showAttract: () => set({ screen: "attract", activeFlow: null }),
  showHome: () => set({ screen: "home", activeFlow: null }),
  openFlow: (flow) => set({ screen: "flow", activeFlow: flow }),
  resetSession: () => set({ screen: "attract", activeFlow: null })
}));
